import { Icon, IconProps } from '@chakra-ui/react';
import React from 'react';

export const CheckmarkThin = (props: IconProps): JSX.Element => {
  return (
    <Icon xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" {...props}>
      <path
        d="M11 22C8.06126 22 5.29968 20.856 3.22126 18.7787C1.14284 16.7015 0 13.9387 0 11.0012C0 8.06242 1.144 5.30084 3.22126 3.22242C5.29853 1.144 8.06126 0 11 0C13.9387 0 16.7003 1.144 18.7787 3.22242C20.8572 5.30084 22 8.06242 22 11.0012C22 13.9399 20.856 16.7015 18.7787 18.7787C16.7015 20.856 13.9387 22 11 22ZM11 1.15789C5.57295 1.15789 1.15789 5.57295 1.15789 11C1.15789 16.4271 5.57295 20.8421 11 20.8421C16.4271 20.8421 20.8421 16.4271 20.8421 11C20.8421 5.57295 16.4271 1.15789 11 1.15789Z"
        fill="currentColor"
      />
      <path
        d="M8.68402 15.6314C8.53581 15.6314 8.3876 15.5747 8.27413 15.4624L4.80045 11.9887C4.57466 11.7629 4.57466 11.3959 4.80045 11.1701C5.02624 10.9443 5.39329 10.9443 5.61908 11.1701L8.68287 14.2339L16.3782 6.53848C16.604 6.31269 16.9711 6.31269 17.1969 6.53848C17.4227 6.76427 17.4227 7.13133 17.1969 7.35711L9.0916 15.4624C8.97813 15.5759 8.82992 15.6314 8.68171 15.6314H8.68402Z"
        fill="currentColor"
      />
    </Icon>
  );
};
